<template>
    <div class="card">
        <div class="flex justify-between items-center">
            <h4 class="card__title">Projekt</h4>
            <toggle-table-columns store-name="deliveryProjectsTable" />
        </div>

        <div class="overflow-x-auto">
            <table class="table mt-0">
                <thead>
                    <tr>
                        <th>
                            Projektnamn
                            <slot name="sorting" />
                        </th>
                        <th
                            v-for="column in selectedColumns"
                            :key="`delivery-project-thead-${column.value}`"
                            class="min-w-lg"
                        >
                            {{ column.label }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="deliveryProject in deliveryProjects"
                        :key="`delivery-project-${deliveryProject.id}`"
                    >
                        <td>
                            <a :href="route('admin.delivery-projects.show', deliveryProject)">
                                {{ deliveryProject.name }}
                            </a>
                        </td>
                        <toggle-table-td-item
                            v-for="column in selectedColumns"
                            :key="`delivery-project-tbody-${deliveryProject.id}-${column.value}`"
                            :model="deliveryProject"
                            :column="column"
                            store-name="deliveryProjectsTable"
                        />
                    </tr>
                    <tr v-if="! deliveryProjects.length">
                        <td
                            :colspan="selectedColumns.length"
                            class="empty-state"
                        >
                            Det finns inga leveransprojekt som matchar filtreringen.
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        props: {
            deliveryProjects: {
                type: Array,
                required: true,
            },
        },
        computed: mapGetters({
            selectedColumns: 'deliveryProjectsTable/selectedColumns',
            shouldShowColumn: 'deliveryProjectsTable/shouldShowColumn',
        }),
    };
</script>
